// extracted by mini-css-extract-plugin
export default {"weekTitleDiv":"dateWithScoreHeaderLine_weekTitleDiv__qAK5-","weekTitleScoreDiv":"dateWithScoreHeaderLine_weekTitleScoreDiv__G3eOu"};